import { Viber } from "@/icons/Viber.tsx";
import { FC } from "react";

interface ViberShareProps {
  text?: string;
  url?: string;
  onError?: () => void;
}

export const ViberShareButton: FC<ViberShareProps> = ({
  text,
  url,
  onError,
}) => {
  const handleViberShare = () => {
    const shareText = text ? encodeURIComponent(text) : "";
    const shareUrl = url ? encodeURIComponent(url) : "";

    const forwardContent =
      shareText && shareUrl
        ? `${shareText}%20${shareUrl}`
        : shareText || shareUrl;

    const viberUrl = `viber://forward?text=${forwardContent}`;

    // Create a timeout to detect if the app didn't open
    const timeout = setTimeout(() => {
      // If this runs, Viber didn't open
      if (onError) {
        onError();
      } else {
        // Fallback to web version
        window.open("https://viber.com/download/", "_blank");
      }
    }, 2500);

    // Try to open Viber
    window.open(viberUrl, "_blank");

    // Clear the timeout if the window loses focus (meaning the app opened)
    window.onblur = () => {
      clearTimeout(timeout);
    };
  };

  return (
    <button onClick={handleViberShare}>
      <Viber size={32} />
    </button>
  );
};
